<template>
  <MainLayout>
    <div class="settings">
      <div class="settings__menu">
        <div class="settings__menu-title">
          {{ $t(`settings.title`) }}
        </div>
        <ul class="settings__menu-items">
          <router-link
            v-for="{ icon, name, to } in menuItems"
            tag="li"
            class="settings__menu-item"
            exact-active-class="settings__menu-item--active"
            :key="name"
            :to="to"
          >
            <div class="settings__menu-item-icon">
              <img :src="icon" :alt="name">
            </div>
            {{ name }}
          </router-link>
        </ul>
      </div>
      <div class="settings__content">
        <router-view />
      </div>
    </div>
  </MainLayout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import MainLayout from '@/components/layouts/MainLayout';

import TimeIcon from '@/assets/icons/time.svg';
import SubscriptionIcon from '@/assets/icons/subscription.svg';

const { mapState } = createNamespacedHelpers('user');

export default {
  name: 'Settings',
  components: { MainLayout },
  computed: {
    ...mapState({
      menuItems(state){
        const items = [
          {
            icon: TimeIcon,
            name: 'Time modifications',
            to: { name: 'settings-time' },
          },
        ];
        if( state.details && typeof state.details.billingPeriodEnd !== 'undefined' ){
          items.push({
            icon: SubscriptionIcon,
            name: 'Subscription',
            to: { name: 'settings-subscription' },
          });
        }
        return items;
      }
    }),

  },
};
</script>

<style lang="scss">
  .settings {
    border-radius: 18px;
    box-shadow: 0 2px 83px 0 rgba(34, 48, 87, .07);
    overflow: hidden;

    @include md-up {
      display: flex;
      min-height: 750px;
    }

    &__menu {
      background-color: $blueDark;
      color: $white;


      @include md-up {
        flex: 0 0 280px;
      }
    }

    &__menu-title {
      display: none;

      @include md-up {
        display: flex;
        height: 124px;
        background-color: lighten($blueDark, 4%);
        padding: 0 40px;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        letter-spacing: .24px;
        color: #ffffff;
      }
    }

    &__menu-items {
      list-style: none;
      padding: 32px;

      @include md-up {
        padding: 64px 30px;
      }
    }

    &__menu-item {
      align-items: center;
      cursor: pointer;
      display: flex;
      font-size: 15px;
      letter-spacing: .4px;

      &:not(:last-child) {
        margin-bottom: 24px;
      }

      &--active {
        font-weight: 600;
        
        div {
          background-color: $accent;
        }
      }
    }

    &__menu-item-icon {
      border-radius: 8px;
      border: solid 1px rgba($white, .2);
      height: 40px;
      margin-right: 20px;
      width: 40px;

      @include center-content;

      &--active {
        background-color: $accent;

        div {
          background-color: $accent;
        }
      }
    }

    &__content {
      background-color: $white;
      padding: 32px 16px;

      @include md-up {
        flex-grow: 1;
        padding: 0;
      }
    }
  }
</style>
